import {
  forwardRef,
  IconButton as BaseIconButton,
  IconButtonProps as BaseIconButtonProps,
} from '@chakra-ui/react';

type Props = BaseIconButtonProps;

const IconButton = forwardRef(({ variant, ...props }: Props, ref) => (
  <BaseIconButton ref={ref} {...props} variant={variant || 'default'} />
));

export default IconButton;
